import * as React from 'react'
import { Route } from 'react-router'
import { Link } from 'react-router-dom'

interface OwnProps {
	to: string
	exact?: boolean
	className?: string
	inactiveClassName?: string
	activeClassName?: string
	linkClassName?: string
	linkTitle?: string
}

export default class MyNavLink extends React.Component<OwnProps> {
	public render() {
		return (
			<Route 
				path={this.props.to}
				exact={this.props.exact} 
				children={({ match }) => (
					<li className={(this.props.className || '') + (match ? (this.props.activeClassName ? ' ' + this.props.activeClassName : '') : (this.props.inactiveClassName ? ' ' + this.props.inactiveClassName : ''))}>
						<Link className={this.props.linkClassName} to={this.props.to} aria-label={this.props.linkTitle}>
							{this.props.children}
						</Link>
					</li>
				)}
			/>
		)
	}
}
